module.exports = __webpack_public_path__ + "images/emoji/trolleybus.a78d9980052a5a802891.png";